import { FloatingLabelInput, FloatingLabelSelect, FormCheckbox } from '../../components.js';
import { EditPage, populateEditForm } from '../crud/shared.js';

export class AdminsEdit extends EditPage {
  static title = "Admins";
  static roleOptions = [
    { value: 'owner', label: 'Owner' },
    { value: 'admin', label: 'Admin' },
    { value: 'editor', label: 'Editor' },
    { value: 'viewer', label: 'Viewer' }
  ];
  static statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'invited', label: 'Invited' },
    { value: 'suspended', label: 'Suspended' }
  ];

  static timlComponents = {
    ...EditPage.timlComponents,
    FloatingLabelSelect,
    FormCheckbox
  };

  static get formAction() {
    return API.resourceUrl('admins', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Admins" href="/admins" nameHref="/admins/{{ Routing.params.id }}" compact="true" nameStyle="" nameSeparatorStyle="" suffix="Edit" suffixStyle="" suffixSeparatorStyle="">

    form.stacked-form[method="PATCH" action="{{ Routing.routeObject.formAction }}"]
      <FloatingLabelInput label="Email" name="email">
      <FloatingLabelSelect label="Role" name="role" options="{{ Routing.routeObject.roleOptions }}">
      <FloatingLabelSelect label="Status" name="status" options="{{ Routing.routeObject.statusOptions }}">
      <FormCheckbox label="Can Invite" name="canInvite">
      <FormCheckbox label="Can Create" name="canCreate">
      <FormCheckbox label="Can Update" name="canUpdate">
      <FormCheckbox label="Can View" name="canView">
      <FormCheckbox label="Can Delete" name="canDelete">
      .horizontal-flex.mt-15
        <FormButton label="Update">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}/delete"] Delete
  `;

  static javascript() {
    API.get(API.resourceUrl('admins', Routing.params.id))
      .then(data => {
        populateEditForm(data.data);
        document.querySelector('#name').innerHTML = data.data.email;
        document.querySelector('.fade:not(.in)').classList.add('in');
      });
  }
}
